/** The Add clinic dialog, wherever a clinic that isn't on file is added. */
export const addClinicCopy = {
  /** The last item of a clinic select, which opens the dialog. */
  action: 'Add New Clinic',
  title: 'Add Clinic',
  labels: {
    name: 'Clinic Name',
    npi: 'HCO NPI',
    addressLine1: 'Address',
    addressLine2: 'Address Line 2',
    city: 'City',
    state: 'State',
    zipCode: 'Zip',
    phone: 'Phone',
    fax: 'Fax',
  },
  placeholders: {
    name: 'Name',
    npi: '0000000000',
    addressLine1: '123 Street Name',
    city: 'City Name',
    state: 'Select one…',
    zipCode: '00000',
    phone: '(000) 000-0000',
    fax: '(000) 000-0000',
  },
  optional: 'Optional',
  save: 'Save',
} as const;
